import {
  extensionViewOf,
  formatCount,
  formatReference,
  formatText,
  productExtensionStateOf,
  type ExtensionSpec,
  type ExtensionView,
  type ProductExtensionEnvelope,
  type ProductExtensionState,
} from '@krp/client-runtime'

import { AQSI_EXTENSION_KIND, aqsiProductExtension } from '../api/productExtensionApi'

const propertiesText = (count: number): string => {
  const rest = count % 10
  const teen = count % 100 >= 11 && count % 100 <= 14
  if (rest === 1 && !teen) return `${count} свойство`
  if (rest >= 2 && rest <= 4 && !teen) return `${count} свойства`
  return `${count} свойств`
}

/**
 * Что показываем из расширения карточки AQSI по версиям схемы. Состав `payload` v1 — решение службы AQSI (RP-FB71, 3.2):
 * группа, тип, оригиналы кассовых полей кабинета и свойства. Поля, которых в снимке нет, не показываются.
 */
export const AQSI_EXTENSION_SPEC: ExtensionSpec = {
  versions: {
    1: [
      { id: 'groupId', label: 'Группа', inSummary: true, format: formatReference('в группе', 'вне групп') },
      { id: 'type', label: 'Тип', inSummary: true, format: formatText },
      { id: 'customProperties', label: 'Свойства', inSummary: true, format: formatCount(propertiesText) },
      { id: 'tax', label: 'Налог в кабинете', inSummary: false, format: formatText },
      { id: 'subject', label: 'Предмет расчёта в кабинете', inSummary: false, format: formatText },
      { id: 'paymentMethodType', label: 'Способ расчёта в кабинете', inSummary: false, format: formatText },
      { id: 'unit', label: 'Единица', inSummary: false, format: formatText },
      { id: 'unitCode', label: 'Код единицы', inSummary: false, format: formatText },
    ],
  },
}

/** Вид расширения карточки AQSI: чистая функция, без запроса. */
export const aqsiExtensionViewOf = (envelope: ProductExtensionEnvelope): ExtensionView => extensionViewOf(envelope, AQSI_EXTENSION_SPEC)

/** Читает расширение карточки AQSI у службы AQSI и отдаёт готовый вид. */
export function useAqsiProductExtension(resourceId: string, remoteKey: string): ProductExtensionState {
  const result = aqsiProductExtension.useQuery({ resourceId, goodId: remoteKey })
  return productExtensionStateOf(result, AQSI_EXTENSION_SPEC)
}

/** Описание вида «AQSI» для реестра источников товара (composition): только то, что знает пакет вида. */
export const aqsiProductExtensionSource = {
  kind: AQSI_EXTENSION_KIND,
  useExtension: useAqsiProductExtension,
} as const
